import React from 'react';
import Button from '../../components/ui/Button';
import type { QuotationGridLayoutState } from './useQuotationGridLayout';

/**
 * The items grid's column-layout controls, for the toolbar above it: Reset
 * columns (ClickUp 86d478wd1) and Save columns (owner's request, 2026-09-17).
 *
 * Returns a fragment, like `GlobalMarkupBar`: the page's toolbar row lays these
 * out beside the markup controls. Each button appears only when it would do
 * something, so neither is a permanently-present control that does nothing.
 */
export const QuotationGridLayoutButtons: React.FC<{ grid: QuotationGridLayoutState }> = ({ grid }) => (
  <>
    {/* The escape hatch for the draggable columns. A layout dragged into an
        unusable state is otherwise stuck on screen until the page is left. */}
    {grid.canReset && (
      <Button
        size="sm"
        onClick={grid.resetLayout}
        title="Put every column back to its original position and width. Save afterwards to make that your saved layout."
      >
        Reset columns
      </Button>
    )}
    {grid.canSave && (
      <Button
        size="sm"
        onClick={() => {
          void grid.saveLayout();
        }}
        loading={grid.saving}
        title="Save this column order and these widths as yours. Every quotation you open will show them, on any computer."
      >
        Save columns
      </Button>
    )}
    {grid.justSaved && !grid.canSave && (
      <span role="status" className="text-xs text-slate-500">
        Columns saved. Every quotation you open will use them.
      </span>
    )}
    {grid.saveError && (
      <span role="alert" className="text-xs text-red-700">
        {grid.saveError}
      </span>
    )}
    {grid.loadFailed && !grid.saveError && (
      <span className="text-xs text-slate-500">Your saved columns could not be loaded.</span>
    )}
  </>
);

export default QuotationGridLayoutButtons;
